/* eslint-disable no-unused-vars */
import { IModel } from '@src/js/separate-logic/interface/IModel';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { isAudioElement } from '@src/slide/domain/ui-model/elements/element-judge';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';

export default class ImageModel implements IModel {
    public isEditMode: boolean;
    public shouldRenderMedia: boolean;
    public initModel(props: any) {
        this.isEditMode = this.getMediaManager().isEditMode;
        this.shouldRenderMedia = !(browser.isMobile
            && !this.getMediaManager().isEditMode && !isAudioElement(props.component));
    }

    private getMediaManager() {
        const appServices = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appServices.viewableServiceLayer.mediaManager;
    }
}

